import { Popover, Transition } from '@headlessui/react';
import Link from 'next/link';

import { storyblokLink } from '@/helpers/storyblokLink';

import DynamicDropdowns from './Dropdowns';

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ');
}

function Arrow({ open = false, dark = false, className = '' }) {
  if (dark) {
    if (!open) {
      return (
        <div className={className} aria-hidden="true">
          <svg
            width="22"
            height="21"
            viewBox="0 0 22 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.7661 7.25802C15.6091 7.09508 15.3962 7.00389 15.1741 7.00389C14.952 7.00389 14.7391 7.09508 14.5821 7.25802L11.0063 10.9225L7.42188 7.24944C7.09497 6.91552 6.56682 6.91686 6.24251 7.25346C5.91754 7.59006 5.9195 8.13387 6.24641 8.46846L10.4143 12.7599C10.5732 12.9174 10.7861 13.0033 11.0063 12.9999C11.2251 12.9992 11.4348 12.9094 11.5898 12.7511L15.7576 8.45974C16.0774 8.1285 16.0813 7.59408 15.7661 7.25815L15.7661 7.25802Z"
              fill="white"
            />
          </svg>
        </div>
      );
    }
    return (
      <div className={className} aria-hidden="true">
        <svg
          width="22"
          height="21"
          viewBox="0 0 22 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="1"
            y="1"
            width="20"
            height="19"
            rx="9.5"
            fill="#1E1E1E"
            fillOpacity="0.2"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.23393 12.742C6.39088 12.9049 6.60384 12.9961 6.82591 12.9961C7.04797 12.9961 7.26093 12.9049 7.41788 12.742L10.9937 9.07746L14.5781 12.7506C14.905 13.0845 15.4332 13.0831 15.7575 12.7465C16.0825 12.4099 16.0805 11.8661 15.7536 11.5315L11.5857 7.24014C11.4268 7.08256 11.2139 6.99673 10.9937 7.00009C10.7749 7.00077 10.5652 7.09062 10.4102 7.24886L6.24236 11.5403C5.9226 11.8715 5.9187 12.4059 6.2339 12.7418L6.23393 12.742Z"
            fill="white"
          />
        </svg>
      </div>
    );
  }

  if (!open) {
    return (
      <div className={className} aria-hidden="true">
        <svg
          width="22"
          height="21"
          viewBox="0 0 22 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.7661 7.25802C15.6091 7.09508 15.3962 7.00389 15.1741 7.00389C14.952 7.00389 14.7391 7.09508 14.5821 7.25802L11.0063 10.9225L7.42188 7.24944C7.09497 6.91552 6.56682 6.91686 6.24251 7.25346C5.91754 7.59006 5.9195 8.13387 6.24641 8.46846L10.4143 12.7599C10.5732 12.9174 10.7861 13.0033 11.0063 12.9999C11.2251 12.9992 11.4348 12.9094 11.5898 12.7511L15.7576 8.45974C16.0774 8.1285 16.0813 7.59408 15.7661 7.25815L15.7661 7.25802Z"
            fill="#1E1E1E"
          />
        </svg>
      </div>
    );
  }
  return (
    <div className={className} aria-hidden="true">
      <svg
        width="22"
        height="21"
        viewBox="0 0 22 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="1"
          y="1"
          width="20"
          height="19"
          rx="9.5"
          fill="#1E1E1E"
          fillOpacity="0.2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.23393 12.742C6.39088 12.9049 6.60384 12.9961 6.82591 12.9961C7.04797 12.9961 7.26093 12.9049 7.41788 12.742L10.9937 9.07746L14.5781 12.7506C14.905 13.0845 15.4332 13.0831 15.7575 12.7465C16.0825 12.4099 16.0805 11.8661 15.7536 11.5315L11.5857 7.24014C11.4268 7.08256 11.2139 6.99673 10.9937 7.00009C10.7749 7.00077 10.5652 7.09062 10.4102 7.24886L6.24236 11.5403C5.9226 11.8715 5.9187 12.4059 6.2339 12.7418L6.23393 12.742Z"
          fill="#1E1E1E"
        />
      </svg>
    </div>
  );
}

function NavDesktop({ navigation, dark = false }) {
  return (
    <Popover.Group
      as="nav"
      className="relative hidden items-end justify-end gap-4 lg:flex xl:gap-6 2xl:gap-8"
    >
      {navigation?.map((item) => (
        <div key={item._uid}>
          {item.dropdown?.length ? (
            <Popover>
              {({ open }) => (
                <>
                  <Popover.Button
                    className={classNames(
                      'group inline-flex items-end text-base 2xl:text-lg px-2 py-2 outline-nonehover:text-theme-primary leading-tight text-left text-lg font-heading font-normal transition duration-500 hover:duration-75 ease-in-out'
                    )}
                  >
                    <span className="text-left leading-6">
                      {item?.label ? item.label : item.name}
                    </span>
                    <Arrow
                      open={open}
                      dark={dark}
                      className={classNames(
                        open
                          ? 'text-theme-primary'
                          : `text-lift-black hover:text-theme-primary`,
                        'h-4 w-4 my-1.5 2xl:my-2 '
                      )}
                    />
                  </Popover.Button>
                  <Transition
                    enter="transition ease-out duration-200"
                    enterFrom="opacity-0 translate-y-1 absolute right-0 "
                    enterTo="opacity-100 translate-y-0 absolute right-0 "
                    leave="transition ease-in duration-150"
                    leaveFrom="opacity-100 translate-y-0 absolute right-0 "
                    leaveTo="opacity-0 translate-y-1 absolute right-0"
                    className="absolute right-0"
                  >
                    <Popover.Panel className="z-20 -ml-4 mt-6">
                      <div className="bg-white shadow-xl">
                        <div className="relative flex gap-12">
                          {item.dropdown?.map((dropdown) => (
                            <DynamicDropdowns
                              key={dropdown._uid}
                              dropdown={dropdown}
                            />
                          ))}
                        </div>
                      </div>
                    </Popover.Panel>
                  </Transition>
                </>
              )}
            </Popover>
          ) : (
            <>
              {item.page ? (
                <Link
                  href={storyblokLink(item.page)}
                  className={`group mb-px inline-block p-2 text-left font-heading text-lg font-normal leading-tight transition duration-500 ease-in-out hover:text-theme-primary hover:duration-75`}
                >
                  <span
                    id={`nav-${item?.label ? item.label : item.name}`}
                    className="block whitespace-break-spaces text-left"
                  >
                    {item?.label ? item.label : item.name}
                  </span>
                </Link>
              ) : (
                <span
                  className={`group inline-block items-center p-2 font-heading text-lg font-normal leading-tight transition duration-500 ease-in-out hover:text-theme-primary hover:duration-75`}
                >
                  {item?.label ? item.label : item.name}
                </span>
              )}
            </>
          )}
        </div>
      ))}
    </Popover.Group>
  );
}
export default NavDesktop;
